import {safeDateFormat} from "./helper/helper";

export const userColumns = [
  { field: "id", headerName: "ID", width: 100 },
  { field: "region_id", headerName: "Region Id", width: 100 },

  // {
  //   field: "user",
  //   headerName: "User",
  //   width: 230,
  //   // renderCell: (params) => {
  //   //   return (
  //   //     <div className="cellWithImg">
  //   //       <img className="cellImg" src={params.row.img} alt="avatar" />
  //   //       {params.row.username}
  //   //     </div>
  //   //   );
  //   // },
  // },
  {
    field: "email",
    headerName: "Email",
    width: 230,
  },

  {
    field: "username",
    headerName: "Name",
    width: 100,
  },
  {
    field: "company_name",
    headerName: "Company Name",
    width: 200,
  },
  {
    field: "role_id",
    headerName: "Role",
    width: 160,
    renderCell: (params) => {
      const roleId = params.row.role_id;
      const roleName =
        roleId === 1
          ? "Admin"
          : roleId === 2
          ? "Customer"
          : roleId === 99
          ? "Superadmin"
          : params.row.status || `Role ${roleId || "-"}`;
      const statusClass =
        roleId === 1 ? "active" : roleId === 2 ? "pending" : "passive";
      return (
        <div className={`cellWithStatus ${statusClass}`}>
          {roleName}
        </div>
      );
    },
  },
];

export const SiteLocalColumns = [
  { field: "id", headerName: "ID", width: 100 },
  { field: "name_site", headerName: "Site Name", width: 300 },

  // {
  //   field: "user",
  //   headerName: "User",
  //   width: 230,
  //   // renderCell: (params) => {
  //   //   return (
  //   //     <div className="cellWithImg">
  //   //       <img className="cellImg" src={params.row.img} alt="avatar" />
  //   //       {params.row.username}
  //   //     </div>
  //   //   );
  //   // },
  // },
  {
    field: "pop_id",
    headerName: "POP ID",
    width: 300,
  },
  {
    field: "bandwith",
    headerName: "Bandwidth",
    width: 300,
  },
  {
    field: "status_site",
    headerName: "Status",
    width: 200,
    renderCell: (params) => {
      return (
          <div className={`cellWithStatus ${params.row.status_site}`}>
            {params.row.status_site}
          </div>
      );
    },
  },

];



export const ticketSolvedColumns = [
  {
    field: "ticket_id",
    headerName: "Ticket ID",
    width: 100,
  },
  {
    field: "date_submit",
    headerName: "Date Submit",
    width: 180,
    renderCell: (params) => safeDateFormat(params.value, true),
  },
  {
    field: "month",
    headerName: "Months",
    width: 100,
  },
  {
    field: "year",
    headerName: "Years",
    width: 100,
  },
  {
    field: "region_id",
    headerName: "Region ID",
    width: 100,
  },
  {
    field: "user_id",
    headerName: "User ID",
    width: 100,
  },
  {
    field: "segment_customer",
    headerName: "Segment Customer",
    width: 230,
  },
  {
    field: "summary",
    headerName: "Summary",
    width: 230,
  },
  {
    field: "action",
    headerName: "Action Team",
    width: 230,
  },
  {
    field: "note",
    headerName: "Note",
    width: 200,
  },
  {
    field: "down_time",
    headerName: "Down Time",
    width: 250,
    renderCell: (params) => safeDateFormat(params.value, true),
  },
  {
    field: "up_time",
    headerName: "UP Time",
    width: 250,
    renderCell: (params) => safeDateFormat(params.value, true),
  },
  {
    field: "status_id",
    headerName: "Status",
    width: 160,
    renderCell: (params) => (
        <div className={`cellWithStatus ${params.row.status_id}`}>
          {params.row.status_id}
        </div>
    ),
  },
  {
    field: "category_id",
    headerName: "Category",
    width: 230,
  },
  {
    field: "updated_at",
    headerName: "Updated Ticket",
    width: 180,
    renderCell: (params) => safeDateFormat(params.value, true),
  },
  {
    field: "created_at",
    headerName: "Created Ticket",
    width: 250,
    renderCell: (params) => safeDateFormat(params.value, true),
  },
];


export const ticketSolvedNumberColumns = [
  { field: "id", headerName: "ID", width: 50 },
  {
    field: "number_ticket",
    headerName: "Number Ticket RFO",
    width: 200,
  },
  {
    field: "ticket_id",
    headerName: "Ticket ID",
    width: 100,
  },
  {
    field: "date_submit",
    headerName: "Date Submit",
    width: 100,
    renderCell: (params) => safeDateFormat(params.value, true),
  },
  {
    field: "month",
    headerName: "Months",
    width: 100,
  },
  {
    field: "year",
    headerName: "Years",
    width: 100,
  },
  {
    field: "region_id",
    headerName: "Region ID",
    width: 100,
  },


  {
    field: "user_id",
    headerName: "User ID",
    width: 100,
  },
  {
    field: "segment_customer",
    headerName: "Segment Customer",
    width: 230,
  },
  {
    field: "summary",
    headerName: "Summary",
    width: 230,
  },
  {
    field: "action",
    headerName: "Action Team",
    width: 230,
  },
  {
    field: "note",
    headerName: "Note",
    width: 200,
  },
  {
    field: "down_time",
    headerName: "Down Time",
    width: 250,
    renderCell: (params) => safeDateFormat(params.value, true),
  },
  {
    field: "status_id",
    headerName: "Status",
    width: 160,
    renderCell: (params) => {
      return (
          <div className={`cellWithStatus ${params.row.status_id}`}>
            {params.row.status_id}
          </div>
      );
    },
  },
  {
    field: "category_id",
    headerName: "Category",
    width: 230,
  },
  {
    field: "updated_at",
    headerName: "Updated Ticket",
    width: 180,
    renderCell: (params) => safeDateFormat(params.value, true),
  },

  {
    field: "created_at",
    headerName: "Created Ticket",
    width: 180,
    renderCell: (params) => safeDateFormat(params.value, true),
  },

];

export const TickeClosecolumns = [
  { field: "id", headerName: "ID", width: 80 },
  { field: "ticket_id", headerName: "Ticket ID", width: 150 },
  { field: "classification", headerName: "Classification", width: 150 },
  { field: "tt_aging", headerName: "TT Aging", width: 300 },
  { field: "sla", headerName: "SLA", width: 120 },
  { field: "close_ticket_by", headerName: "Closed By", width: 150 },

  {
    field: "created_at",
    headerName: "Created At",
    width: 150,
    type: "dateTime",
    renderCell: (params) => safeDateFormat(params.value),
  },

  {
    field: "updated_at",
    headerName: "Updated At",
    width: 150,
    type: "dateTime",
    renderCell: (params) => safeDateFormat(params.value),
  },
];




export const  ticketDetailcolumns = [
  { field: "ticket_id", headerName: "Ticket ID", width: 150 },
  { field: "date_submit", headerName: "Date Submitted", width: 280, type: 'dateTime',
    renderCell: (params) => safeDateFormat(params.value, true),


  },
  {
    field: "month",
    headerName: "Months",
    width: 100,
  },
  {
    field: "year",
    headerName: "Years",
    width: 100,
  },
  {
    field: "region_id",
    headerName: "Region ID",
    width: 100,
  },
  { field: "user_id", headerName: "User ID", width: 150 },

  { field: "segment_customer", headerName: "Segment Customer", width: 180 },
  { field: "number_ticket", headerName: "Number Ticket RFO", width: 180 },
  { field: "down_time", headerName: "Down Time", width: 250, type: 'dateTime',
    renderCell: (params) => safeDateFormat(params.value, true),



  },
  { field: "up_time", headerName: "Up Time", width: 250, type: 'dateTime',
    renderCell: (params) => safeDateFormat(params.value, true),

  },
  { field: "summary", headerName: "Summary", width: 200 },
  { field: "action", headerName: "Action", width: 150 },
  { field: "note", headerName: "Note", width: 200 },
  {
    field: "status_id",
    headerName: "Status",
    width: 160,
    renderCell: (params) => {
      return (
          <div className={`cellWithStatus ${params.row.status_id}`}>
            {params.row.status_id}
          </div>
      );
    },
  },

  { field: "category_id", headerName: "Category ID", width: 150 },
  { field: "start_pending", headerName: "Start Pending", width: 150,
    renderCell: (params) => safeDateFormat(params.value, true),


  },
  { field: "start_pending2", headerName: "Start Pending 2", width: 150,
    renderCell: (params) => safeDateFormat(params.value, true),


  },
  { field: "end_pending", headerName: "End Pending", width: 150,
    renderCell: (params) => safeDateFormat(params.value, true),


  },
  { field: "end_pending2", headerName: "End Pending 2", width: 150,
    renderCell: (params) => safeDateFormat(params.value, true),
  },
  { field: "classification", headerName: "Classification", width: 150 },
  { field: "tt_aging", headerName: "TT Aging", width: 300 },
  { field: "sla", headerName: "SLA", width: 120 },
  { field: "close_ticket_by", headerName: "Closed By", width: 150 },
]



export const  ticketDetailLocalSitecolumns = [
  { field: "id", headerName: "Ticket ID", width: 150 },
  { field: "number_tt", headerName: "Nomor TT", width: 150 },

  { field: "customer_site", headerName: "Customer Site", width: 150 },
  { field: "pop_id", headerName: "POP ID", width: 250 },
  { field: "created_at", headerName: "Date Submit", width: 250,
    renderCell: (params) => safeDateFormat(params.value, true),

  },
  {
    field: "months",
    headerName: "Months",
    width: 100,
  },
  {
    field: "years",
    headerName: "Years",
    width: 100,
  },
  {
    field: "region_id",
    headerName: "Region ID",
    width: 100,
  },
  {
    field: "vendor_id",
    headerName: "Vendor ID",
    width: 100,
  },
  { field: "staff_open_ticket", headerName: "Staff Open Ticket", width: 150 },
  { field: "down_time", headerName: "Down Time", width: 250,
    renderCell: (params) => safeDateFormat(params.value, true),
  },
  { field: "up_time", headerName: "Up Time", width: 250,
    renderCell: (params) => safeDateFormat(params.value, true),

  },
  {
    field: "status_id",
    headerName: "Status",
    width: 160,
    renderCell: (params) => {
      return (
          <div className={`cellWithStatus ${params.row.status_id}`}>
            {params.row.status_id}
          </div>
      );
    },
  },
  {
    field: "category_id",
    headerName: "Category Id",
    width: 150,
  },
  { field: "start_pending", headerName: "Start Pending", width: 150,
    renderCell: (params) => safeDateFormat(params.value, true),


  },
  { field: "start_pending2", headerName: "Start Pending 2", width: 150,
    renderCell: (params) => safeDateFormat(params.value, true),


    },
  { field: "end_pending", headerName: "End Pending", width: 150,
    renderCell: (params) => safeDateFormat(params.value, true),


  },
  { field: "end_pending2", headerName: "End Pending 2", width: 150,
    renderCell: (params) => safeDateFormat(params.value, true),

  },


  { field: "root_cause", headerName: "Root Cause", width: 200 },
  { field: "action", headerName: "Action", width: 150 },
  { field: "note", headerName: "Note", width: 200 },
  { field: "estimation", headerName: "estimation", width: 300 },
  { field: "staff_close_ticket", headerName: "Update Last By", width: 150 },

  { field: "updated_at", headerName: "Updated At", width: 150,
    renderCell: (params) => safeDateFormat(params.value, true),


  },

]
